import makeStyles from '@mui/styles/makeStyles'

export const getStatusColor = (status, theme) => {
  if (status === 'active') {
    return theme.palette.indicator.green
  }

  if (status === 'inactive') {
    return theme.palette.textLight
  }

  return theme.palette.indicator.red
}

const useStyles = makeStyles(theme => ({
  root: {
    height: 'fit-content',
    overflow: 'hidden unset'
  },

  noData: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '60px',
    color: theme.palette.textLightFaded,
    fontSize: theme.size.lg
  },

  dataRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },

  date: {
    opacity: '0.35',
    fontStyle: 'italic'
  }
}))

export default useStyles
